import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'

import { FLOATING_ELEMENT_PLACEMENT as TOOLTIP_PLACEMENT } from '../../constants/common'
import { HTML_LINK_TARGET } from '../../constants/html'
import { MENU_FAQ_ITEM } from '../../constants/menu'
import { useInitData } from '../../hooks'
import { getWebappLinkPrefix } from '../../utils/route'
import Button, { BUTTON_HEIGHT_32 } from '../Button'

import * as styles from './HelpLink.module.css'

import FaqIcon from '../../icons/faq.svg'

function HelpLink({
  Icon = FaqIcon,
  buttonClassName = styles.button,
  height = BUTTON_HEIGHT_32,
  tooltip = 'Header.FaqLinkKey',
  tooltipPlacement = TOOLTIP_PLACEMENT.bottom,
}) {
  const { t } = useTranslation()

  const { availableSections: sections } = useInitData()

  const isAvailableUiFaqSection = sections?.[MENU_FAQ_ITEM.uiSectionName]

  const link = isAvailableUiFaqSection
    ? MENU_FAQ_ITEM.to
    : getWebappLinkPrefix(MENU_FAQ_ITEM.to)

  return (
    <NavLink
      reloadDocument={!isAvailableUiFaqSection}
      target={HTML_LINK_TARGET.blank}
      to={link}
    >
      <Button.Flat
        isGrey
        beforeIconProps={{ Icon }}
        className={buttonClassName}
        height={height}
        tooltip={t(tooltip)}
        tooltipPlacement={tooltipPlacement}
      />
    </NavLink>
  )
}

export default HelpLink
